<template>
    <!-- 穿梭框 -->
    <div class="shuttle-frame" :id="options.id">
        <div ref="left-grid" class="left-grid"></div>
        <div class="center-btn">
            <div class="icon" :class="[options.addList.length > 0 ? 'right-active':'right-gray']" @click="add"></div>
            <div class="icon" :class="[options.delList.length > 0 ? 'left-active':'left-gray']" @click="del"></div>
        </div>
        <div ref="right-grid" class="right-grid"></div>
    </div>
</template>
<script>
export default {
    name: "shuttle-frame",
    props: {
        options: Object
    },

    inject: {
        shuttleFrame: {
            default: null
        }
    },

    methods: {
        add() {
            this.options.addList.length > 0 && !this.options.readonly && this.changeData('add');
        },
        del() {
            this.options.delList.length > 0 && !this.options.readonly && this.changeData('del');
        },
        changeData(type) {
            this.shuttleFrame.initData();
            this.options.chooseGrid = true;
            if (type === 'add') {
                this.options.rightData = [...this.options.rightData, ...this.options.addList];
                this.options.data = this.options.data.filter(item => !this.options.rightData.some(obj => obj[this.options.delRepeatField] === item[this.options.delRepeatField]));
                if (this.options.onAddClick) {
                    this.options.onAddClick(this.options.addList, this.options.data, this.options.rightData);
                }
            } else {
                this.options.data = [...this.options.data, ...this.options.delList];
                this.options.rightData = this.options.rightData.filter(item => !this.options.data.some(obj => obj[this.options.delRepeatField] === item[this.options.delRepeatField]));
                if (this.options.onDelClick) {
                    this.options.onDelClick(this.options.delList, this.options.data, this.options.rightData);
                }
            }

            this.shuttleFrame.leftGrid.loadData(this.options.data);
            this.shuttleFrame.rightGrid.loadData(this.options.rightData);

            setTimeout(()=>{
                this.options.data.forEach((item, index) => {
                        this.shuttleFrame.leftGrid.model.$refs.vm.$refs['checkbox_' + index][0].checked = false;
                });
                this.options.rightData.forEach((item, index) => {
                        this.shuttleFrame.rightGrid.model.$refs.vm.$refs['checkbox_' + index][0].checked = false;
                });

                this.options.addList = [];
                this.options.delList = [];
                this.shuttleFrame.leftOriginalDataHandle();
                this.shuttleFrame.rightOriginalDataHandle();
            });
        }
    }
}
</script>
<style scoped>
.shuttle-frame {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
}

.shuttle-frame .left-grid,
.shuttle-frame .right-grid {
    width: calc(50% - 20px);
}

.shuttle-frame .center-btn {
    width: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.shuttle-frame .center-btn .icon {
    display: flex;
    width: 100%;
    height: 28px;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    border-radius: 4px;
    align-items: center;
}

.shuttle-frame .center-btn .icon:first-child {
    margin-bottom: 16px;
}

.shuttle-frame .center-btn .right-active {
    background: #007aff url(./img/right-arrow-fff.png) no-repeat center;
    cursor: pointer;
}

.shuttle-frame .center-btn .right-gray {
    background: #d9d9d9 url(./img/right-arrow-ccc.png) no-repeat center;
}

.shuttle-frame .center-btn .left-active {
    background: #007aff url(./img/left-arrow-fff.png) no-repeat center;
    cursor: pointer;
}

.shuttle-frame .center-btn .left-gray {
    background: #d9d9d9 url(./img/left-arrow-ccc.png) no-repeat center;
}

.shuttle-frame .left-grid,
.shuttle-frame .center-btn,
.shuttle-frame .right-grid {
    height: 100%;
}

.shuttle-frame .left-grid >>> .grid .toolbar,
.shuttle-frame .right-grid >>> .grid .toolbar,
.shuttle-frame >>> .grid .filter .close {
    display: none;
}
</style>